import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FwPlugins, { IFrame, usePluginReducer } from 'framework-plugins';
import Helmet from 'react-helmet';
import Servizi from 'enums/Servizi';
import Assistente from 'Assistente';
import { bindActionCreators } from 'redux/es';
import { setAnnoSelezionato } from '../../actions/dichiarativiActions';
import useSignalR from '../../helpers/useSignalR';
import checkServizio from '../../helpers/checkServizio';

const SetteTrenta = ({
  ufficio, anniRegistrati, annoSelezionato, impostaAnnoSelezionato,
}) => {
  const url730 = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730;

  useEffect(() => {
    const annoSelezionatoQS = new URLSearchParams(window.location.search || window.location.hash.split('?')[1]).get('annoSelezionato');
    if (annoSelezionatoQS && annoSelezionatoQS != annoSelezionato) {
      debugger;
      impostaAnnoSelezionato(annoSelezionatoQS);
    }
  });

  usePluginReducer(() => (
    {
      CAMBIO_ANNO_730: (payload) => {
        if (payload.Anno !== annoSelezionato) {
          impostaAnnoSelezionato(payload.Anno);
          if (payload.Anno < 2021 && window.location.href.includes('NewSetteTrenta')) {
            window.location.href = `/#/SetteTrenta/${window.location.href.includes('barra-quattro') ? 'Barra4' : 'Elenco'}`;
          }
        }
      },
      ASSISTENTE_APRIPERMALINK: (payload) => {
        Assistente.apriPermalink(payload);
      },
    }));

  // recupera dall'url eventuali parametri specifici
  const location = useLocation();
  const parametriUrl = location.search.split('?');
  const objSrcParam = { codiceUfficio: ufficio };
  // gestisce la callback dal plugin imu/immobili
  // trasmette il parametro "identificatore" alla pagina/quadro di destinazione
  if (parametriUrl && parametriUrl.some((x) => /from=Immobili/i.test(x))) {
    objSrcParam.from = 'Immobili';
  }

  const sendMEssage = useCallback((title, message) => {
    FwPlugins.postMessageToChilds(title, message);
  }, []);

  useSignalR('CreaSetteTrentaDaPassaggioNuovoAnnoTerminata', (data) => sendMEssage('CreaSetteTrentaDaPassaggioNuovoAnnoTerminata', data));
  useSignalR('DichiarazioneStatoModificato', (data) => sendMEssage('DichiarazioneStatoModificato', data));
  useSignalR('DichiarazioneModificaStatoFallita', (data) => sendMEssage('DichiarazioneModificaStatoFallita', data));
  useSignalR('DichiarazioneEliminata', (data) => sendMEssage('DichiarazioneEliminata', data));
  useSignalR('StampaDichiarazioneCompletata', (data) => sendMEssage('StampaDichiarazioneCompletata', data));
  useSignalR('DichiarazioneConErrori', (data) => sendMEssage('DichiarazioneConErrori', data));
  useSignalR('ImportazioneSetteTrentaDaXmlAnnoCorrenteAvviata', (data) => sendMEssage('ImportazioneSetteTrentaDaXmlAnnoCorrenteAvviata', data));
  useSignalR('ImportazioneDichiarazioneDaXmlImportata', (data) => sendMEssage('ImportazioneDichiarazioneDaXmlImportata', data));
  useSignalR('CreaSetteTrentaDaXmlAnnoCorrenteFallito', (data) => sendMEssage('CreaSetteTrentaDaXmlAnnoCorrenteFallito', data));
  useSignalR('ImportazioneDichiarazioneDaXmlTerminata', (data) => sendMEssage('ImportazioneDichiarazioneDaXmlTerminata', data));
  useSignalR('DichiarazioneCreataInAnnoPrecedente', (data) => sendMEssage('DichiarazioneCreataInAnnoPrecedente', data));
  useSignalR('DichiarazioneIntegrativaCreata', (data) => sendMEssage('DichiarazioneIntegrativaCreata', data));
  useSignalR('CreazioneIntegrativaFallita', (data) => sendMEssage('CreazioneIntegrativaFallita', data));
  useSignalR('GenerazioneTributiF24Completata', (data) => sendMEssage('GenerazioneTributiF24Completata', data));
  useSignalR('GeneraTributiF24Fallita', (data) => sendMEssage('GeneraTributiF24Fallita', data));
  useSignalR('GenerazioneTributiF24MassivoTerminato', (data) => sendMEssage('GenerazioneTributiF24MassivoTerminato', data));
  useSignalR('CreaCUDaDatiEstrattiConAITerminataOK', (data) => sendMEssage('CreaCUDaDatiEstrattiConAITerminataOK', data));
  useSignalR('CreaCUDaDatiEstrattiConAITerminataKO', (data) => sendMEssage('CreaCUDaDatiEstrattiConAITerminataKO', data));

  var anniDisponibili = anniRegistrati;
  if(ufficio>=100){
      anniDisponibili = anniRegistrati.filter(x => x.SoloInterni == false);
  }

  return (
    <React.Fragment>
      <Helmet title="730" />
      <IFrame
        key={annoSelezionato}
        src={url730}
        srcParams={objSrcParam}
        extraParams={{ anniDisponibili: anniDisponibili }}
        onRedirectUrl={(url) => {
          window.location = url
            .replace(`${url730}#/`, `${window.location.origin}/#/NewSetteTrenta/`)
            .replace(encodeURIComponent(`${url730}#/`), encodeURIComponent(`${window.location.origin}/#/NewSetteTrenta/`));
        }}
      />
    </React.Fragment>
  );
};

const mapStoreToProps = (store) => ({
  anniRegistrati: store.dichiarativi.anniRegistrati.data,
  ufficio: store.utente.ufficioSelezionato.CodiceUfficio,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

const mapDispatchToProps = (dispatch) => ({
  impostaAnnoSelezionato: bindActionCreators(setAnnoSelezionato, dispatch),
});

SetteTrenta.propTypes = {
  ufficio: PropTypes.string.isRequired,
  anniRegistrati: PropTypes.array.isRequired,
  impostaAnnoSelezionato: PropTypes.func,
};

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, mapDispatchToProps)(SetteTrenta));
